<div class="row tertiaty-buttons task">
  <div class="col-4 button-box small">
    <a
      id="cta-remove-this-line"
      attr.aria-label="{{ aemContent?.removeThisLine }}"
      href="javascript:void(0)"
      tabindex="{{ disableRemoveTileCTA ? '-1' : '0' }}"
      (click)="showRemoveLineModal($event, true)"
      [class.disabled]="isRemoveButtonDisabled"
    >
      <span class="center"><i class="fa fa-close"></i>{{ aemContent?.removeThisLine }}</span>
    </a>
  </div>

  <div class="col-4 button-box small">
    <a
      id="cta-duplicate"
      attr.aria-label="{{ aemContent?.duplicate }}"
      href="javascript:void(0)"
      tabindex="{{ isDuplicateButtonDisabled ? '-1' : '0' }}"
      (click)="duplicateThisLine()"
      [class.disabled]="isDuplicateButtonDisabled || isLineCompleted || isTestDrivePlan"
    >
      <span class="center"> <i class="fa fa-files-o"></i>{{ aemContent?.duplicate }}</span>
    </a>
  </div>
  <div class="col-4 button-box small">
    <a
      id="cta-add-aline"
      attr.aria-label="{{ aemContent?.addALine }}"
      href="javascript:void(0)"
      tabindex="{{ !(isValidToAddALine && !isLineCompleted) ? '-1' : '0' }}"
      [class.disabled]="disableAddALine || isTestDrivePlan"
      (click)="addTile(); updateWorkflow()"
    >
      <span
        class="center"
        *ngIf="
          (isValidToAddALine && !isTouristPlan) || (!isValidToAddALine && isTestDrivePlan);
          else displayAddADevice
        "
      >
        <i class="fa fa-plus"></i>{{ aemContent?.addALine }}</span
      >
      <ng-template #displayAddADevice>
        <span class="center"><i class="fa fa-plus"></i>{{ aemContent?.addAdevice }}</span>
      </ng-template>
    </a>
  </div>
</div>
<tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
<tmo-dynamic-modal [modal]="modal">
  <ng-container header>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo"></i>
      <a
        id="cta-remove-line-confirmation"
        attr.aria-label="{{ aemContent?.removeLineConfirmation }}"
        href="javascript:void(0)"
        tabindex="0"
        class="close-x pull-right"
        (click)="closeModal()"
        ><i class="fa fa-times"></i
      ></a>
    </div>
    <h3>{{ aemContent?.removeLineConfirmation }}</h3>
  </ng-container>
  <div class="col-12 n-padding">
    <p class="small">
      {{ aemContent?.removeLineMessage }}
    </p>
  </div>
  <ng-container footer>
    <div class="row">
      <div class="col-12 buttons-container button-spacing">
        <div class="button-box">
          <button class="btn btn-secondary" (click)="closeModal()" id="btn-default-195">
            {{ aemContent?.cancel }}
          </button>
        </div>
        <div class="button-box">
          <button
            class="btn btn-primary"
            (click)="disableRemoveTileCTA || removeLine()"
            id="btn-default-196"
          >
            {{ aemContent?.continue }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</tmo-dynamic-modal>
